<template>
    <ListView @selected="onSelectedCapability" :items="capabilities" :showIndex="true"></ListView>
</template>

<script>
	import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
	import {Getter, Action} from 'vuex-class';
	import DefaultLayout from '../../layouts/Default';
	import Dialog from '../../components/Dialog';
	import ListView from '../../components/ListView';
	import CapabilitiesView from '../../components/CapabilitiesView';

	@Component({
		components: {
			DefaultLayout,
			Dialog,
			ListView,
			CapabilitiesView
		},
	})
	export default class ViewDeviceInformation extends Vue {
		@Prop(Object) device;

		_capabilities = [];
		capabilities = [];
		
		static getCapabilityDescription(capability) {
		    const capabilityType = capability.type;
            let capabilityUnit = (capability.units ) ? capability.units : '';
			let capabilityValue = capability.value;

			// Format null values
            if (capabilityValue === null) {
                switch (capabilityType) {
                    case 'boolean':
                        capabilityValue = '-';
                        capabilityUnit = '';
                        break;
                    case 'number':
                        capabilityValue = '-';
                        capabilityUnit = '';
                    default:
                    	break;
                }
            }
            else if(capabilityValue === true) capabilityValue = 'Yes';
			else if(capabilityValue === false) capabilityValue = 'No';
			else if(capabilityUnit === '%' && capability.max === 1) capabilityValue *= 100;

            // Replace Celsius sign, not in font
            if (capabilityUnit === '°C') capabilityUnit = 'Deg. C';
            
            const title = capability.title
			let formattedValue = `${capabilityValue} ${capabilityUnit}`;
			if(capability.type === 'enum' && capability.values) {
				const value = capability.values.filter(v => v.id === capability.value)[0];
				if(value)
					formattedValue = value.title;
			}

            return {
                title,
                formattedValue,
                description: `${title}: ${formattedValue}`,
            };
		}

		_setCapabilities() {
			this.capabilities = this._capabilities.map(capabilityInstance => {
                let {title, formattedValue, description} = ViewDeviceInformation.getCapabilityDescription(capabilityInstance);

				return {
					capabilityName: title,
					formattedValue,
					title: description,
					capabilityInstance
				}
			})
		}

		_updateDevice(device) {
			if(this._capabilities)
				this._capabilities.forEach(c => c.destroy());
			this._capabilities = [];
			if(device) {
				this._capabilities = device.capabilities.map(capability => 
					device.makeCapabilityInstance(capability, () => this._setCapabilities())
				);
				this._setCapabilities();
			}
		}

		beforeDestroy() {
			this._updateDevice();
		}

		@Watch('device')
		onDeviceChange(newDevice) {
			this._updateDevice(newDevice);
		}

		beforeMount() {
			this._updateDevice(this.device);
		}

		onSelectedCapability(capability) {
            this.$emit('selected', capability.capabilityInstance);
		}
	}
</script>

<style lang="scss">

</style>